import React from "react";

import { mdiMonitorEdit } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";

import { MENU_ICON_SIZE } from "./Menu";
import MenuItem from "./MenuItem";
import SubMenu from "./SubMenu";
import useAbility from "../../hooks/useAbility";
import { PROJECTS_ROUTE } from "../routes/routes";

import type { JSX } from "react";

import type { AppState } from "../../reducers";

function ContentsSubMenu(): JSX.Element {
  const { t } = useTranslation("editor-menu");
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { canAccess } = useAbility();

  const orgaConfig = useSelector(
    (state: AppState) => state.fetchReducer.orga_config,
  );

  const { project: canAccessProject } = canAccess(
    orgaConfig.data?.organization_options,
  );

  return (
    <SubMenu
      icon={<Icon path={mdiMonitorEdit} size={MENU_ICON_SIZE} />}
      label={t("publishing-management")}
    >
      {canAccessProject.smartlists ? (
        <MenuItem
          label={t("smartlists")}
          component={
            <NavLink to={`${PROJECTS_ROUTE}/${projectSlug}/smartlist`} />
          }
        />
      ) : null}
      {canAccessProject.collections ? (
        <MenuItem
          label={t("collections")}
          component={
            <NavLink to={`${PROJECTS_ROUTE}/${projectSlug}/collections`} />
          }
        />
      ) : null}
      {canAccessProject.series ? (
        <MenuItem
          component={<NavLink to={`${PROJECTS_ROUTE}/${projectSlug}/series`} />}
          label={t("series")}
        />
      ) : null}
      {canAccessProject.smartlistsAudios ? (
        <MenuItem
          label={t("smartlist_audio")}
          component={
            <NavLink to={`${PROJECTS_ROUTE}/${projectSlug}/smartlist_audio`} />
          }
        />
      ) : null}
      {canAccessProject.displays ? (
        <MenuItem
          label={t("displays_item")}
          component={
            <NavLink to={`${PROJECTS_ROUTE}/${projectSlug}/displays`} />
          }
        />
      ) : null}
    </SubMenu>
  );
}

export default ContentsSubMenu;
